'use client';

import {useEffect, useContext} from 'react';

import {Theme} from '@/types/index';
import {SettingContext} from '@/context/Setting';
import {getComputedCSSProperty} from '@/lib/utils';

/** Handles the theme change. */
export function useTheme() {
  const [setting] = useContext(SettingContext)!;

  // Applying theme to the `html` element
  useEffect(() => {
    const html = document.documentElement;
    if (setting.theme === Theme.Dark && !html.classList.contains(Theme.Dark)) {
      html.classList.add(Theme.Dark);
    }
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  // Changing default background color to match the theme
  useEffect(
    () =>
      document
        .querySelector('meta[name="theme-color"]')!
        .setAttribute('content', getComputedCSSProperty('--background')),
    [setting.theme]
  );

  return null;
}
